import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage from "@insite/mobius/LazyImage/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface NewsPageViewStyles {
    authorText?: TypographyProps;
    publishDateText?: TypographyProps;
    newsWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    dateAndAuthorWrapper?: InjectableCss;
    ContentImg?: InjectableCss;
    ImageAndSpecialwrapper?: InjectableCss;
    specialAlert?: InjectableCss;
}

export const newsPageViewStyles: NewsPageViewStyles = {
    newsWrapper: {},
    dateAndAuthorWrapper: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    contentWrapper: {
        css: css`
            margin-top: 8px;
            > p {
                font-size: ${TYPOGRAPHY.size.base} !important;
                font-weight: ${TYPOGRAPHY.weight.baseBold};
            }
            .fr-video {
                iframe {
                    @media (max-width: 768px) {
                        width: 100% !important;
                    }
                }
            }
        `,
    },
    authorText: {
        css: css`
            color: ${COLORS.secondaryNavyOne};
        `,
    },
    publishDateText: {
        css: css`
            margin-right: 8px;
            font-style: italic;
            color: ${COLORS.secondaryNavyOne};
        `,
    },
    ContentImg: {
        css: css`
            width: 100%;
            height: 100%;
            border: 1px solid red;
            img {
                object-fit: cover;
                aspect-ratio: 3/1.7 !important;
                height: auto;
                width: 100%;
                max-height: 175px !important;
            }
            &::after {
                content: "";
                position: absolute;
                width: 49px;
                bottom: -24px;
                right: -24px;
                height: 49px;
                border: 2px solid transparent;
                background-color: white;
                border-image-slice: 10%;
                transform: rotateZ(45deg);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-height: 191px !important;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css``,
                    css``,
                    null,

                    null,
                ])}
        `,
    },
};

const styles = newsPageViewStyles;

const NewsPageView = ({ page }: Props) => {
    if (!page) {
        return null;
    }

    return (
        <StyledWrapper {...styles.newsWrapper} key={page.id}>
            <StyledWrapper {...styles.dateAndAuthorWrapper}>
                {page.fields["publishDate"] && (
                    <Typography {...styles.publishDateText} data-test-selector="newslist_publishdate">
                        <LocalizedDateTime
                            dateTime={new Date(page.fields["publishDate"])}
                            options={{ year: "numeric", month: "numeric", day: "numeric" }}
                        />
                    </Typography>
                )}
                {page.fields["author"] && (
                    <Typography {...styles.authorText} data-test-selector="newslist_author">
                        {page.fields["author"]}
                    </Typography>
                )}
            </StyledWrapper>
            {/* <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                {page.fields["img"] && <LazyImage src={page.fields["img"]} />}
                {page.fields["specialMessage"] && (
                    <StyledWrapper {...styles.specialAlert}>{page.fields["specialMessage"]}</StyledWrapper>
                )}
            </StyledWrapper> */}
            {(page.fields["newsSummary"] || page.fields["newsContent"]) && (
                <StyledWrapper {...styles.contentWrapper} data-test-selector="newslist_content">
                    {parse(page.fields["newsContent"], parserOptions)}
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(NewsPageView),
    definition: {
        group: "News Page",
        allowedContexts: ["NewsPage"],
    },
};

export default widgetModule;
